import isValid from 'date-fns/isValid';

import { Duration } from '../components/Duration';

// 작성시는 Date사용, 저장할때는 string으로 적혀있기 때문에 변환 필요
export function convertDurationFormat(duration?: Duration) {
  if (!duration) {
    return;
  }

  const { startAt = '', endAt = '' } = duration;

  const start = isValid(new Date(startAt)) ? new Date(startAt) : undefined;
  const end = isValid(new Date(endAt)) ? new Date(endAt) : undefined;

  return {
    ...start && { startAt: start },
    ...end && { endAt: end },
  };
}

export function convertRemainTime(timestamp: number = 0) {
  const timeGap = new Date(0, 0, 0, 0, 0, 0, timestamp);

  return {
    days: Math.floor(timestamp / (1000 * 60 * 60 * 24)), // 일
    hours: timeGap.getHours(), // 시
    minutes: timeGap.getMinutes(), // 분
    seconds: timeGap.getSeconds(), // 초
  };
}
